"use client"

import { NotFound } from "@eurodrive/pages"

export default function NotFoundPage() {
  return <NotFound />
}
